import { render } from "./Post.vue?vue&type=template&id=f3a937ba&ts=true"
import script from "./Post.vue?vue&type=script&lang=ts"
export * from "./Post.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__